module.exports = __webpack_public_path__ + "static/careers-article-2ec0e238503e3aec39d0165ae4020028.png";